export default "__VITE_ASSET__CNbxfkLb__"